var _path, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.34,423.9V449h5.79a34.81,34.81,0,0,1,0-7.95c.55-2.95,6.84-10.57,6.65-17.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,423.9V449h5.79a34.81,34.81,0,0,1,0-7.95c.55-2.95,6.84-10.57,6.65-17.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,423.9V449H121.2a35.44,35.44,0,0,0,0-7.95c-.56-2.95-6.84-10.57-6.66-17.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,423.9V449h-5.79a35.44,35.44,0,0,0,0-7.95c-.55-2.95-6.84-10.57-6.65-17.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4,
    y: 300.13,
    width: 138.72,
    height: 124.57,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.75 300.13 133.78 424.7 170.12 424.7 170.12 300.13 132.75 300.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.64,
    y: 309.3,
    width: 89.06,
    height: 31.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.64,
    y: 347.31,
    width: 89.06,
    height: 31.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.64,
    y: 385.33,
    width: 89.06,
    height: 31.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.78 264.34 67.94 299.99 117.16 299.99 121.24 264.34 71.78 264.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.81 266.9 70.07 298.09 114.49 298.09 118.08 266.9 73.81 266.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.28 272.15 78.98 292.85 107.01 292.85 108.45 272.15 81.28 272.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.48 279.69 129.65 300.13 117.16 299.99 119.48 279.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,326.8a3.26,3.26,0,1,1-3.26-3.25A3.26,3.26,0,0,1,85.43,326.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,365.2a3.26,3.26,0,1,1-3.26-3.26A3.25,3.25,0,0,1,85.43,365.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,403.59a3.26,3.26,0,1,1-3.26-3.26A3.26,3.26,0,0,1,85.43,403.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.56 97.63 47.91 96.87 50.1 199.37 128.75 199.66 126.56 97.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.49 102.2 52.64 100.42 54.63 193.38 123.46 194.23 121.49 102.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.74 116.09 64.05 115.33 65.45 180.31 111.09 179.33 109.74 116.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.45 180.31 110.38 145.95 64.05 115.33 65.45 180.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.01 44.2 396 43.53 397.93 133.46 466.92 133.71 465.01 44.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.55 48.22 400.15 46.65 401.9 128.2 462.28 128.94 460.55 48.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.24 60.4 410.17 59.73 411.39 116.73 451.43 115.88 450.24 60.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.39 116.73 450.81 86.59 410.17 59.73 411.39 116.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.71,382.3c-.29.88,10,40,10,40l7.06-1.47-9.71-38.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.42 376.71 428.3 422.3 436.54 422.3 450.07 379.95 442.42 376.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.36 369.65 439.18 422.3 447.42 422.3 463.01 372.89 455.36 369.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.71 419.07 400.95 447.6 442.42 447.6 450.07 419.07 392.71 419.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.1,419.07a2.59,2.59,0,0,1-.09-.3l-.22-.87c-.19-.8-.45-1.93-.79-3.37l-2.85-12.46-9.31-41.55.25.21h-7.26l.25-.32c3.69,16.35,7,31,9.37,41.58,1.16,5.27,2.1,9.52,2.76,12.5.3,1.45.55,2.58.72,3.39.07.37.13.66.17.88a1,1,0,0,1,0,.31,2.59,2.59,0,0,1-.09-.3c-.06-.22-.13-.51-.22-.87-.2-.8-.47-1.93-.82-3.37-.69-3-1.68-7.21-2.91-12.46-2.43-10.58-5.78-25.21-9.52-41.55l-.08-.31h7.8l.05.2c3.59,16.35,6.82,31,9.15,41.58,1.13,5.27,2.05,9.52,2.69,12.5.3,1.45.53,2.58.7,3.39l.17.88A1,1,0,0,1,414.1,419.07Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.63,448.79c0,.14-94.94.26-212,.26s-212-.12-212-.26,94.92-.26,212.05-.26S454.63,448.65,454.63,448.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.33,175.85a3.77,3.77,0,0,0-.71-.22,4.94,4.94,0,0,0-2.17,0,8,8,0,0,0-3.15,1.62,16.65,16.65,0,0,0-3.2,3.73c-2.05,3.14-3.66,7.48-5.54,12.54a183.49,183.49,0,0,0-5.64,17.63v0h0a5.08,5.08,0,0,1-1.16,1.45,2.29,2.29,0,0,1-1.82.58,3.4,3.4,0,0,1-1.67-1c-.47-.43-.91-.89-1.35-1.36a32.17,32.17,0,0,0-2.77-2.7,5.12,5.12,0,0,0-3.51-1.43,4.74,4.74,0,0,0-3.21,2.14,8.13,8.13,0,0,0-1.11,4c-.17,2.86.66,5.75,1.16,8.74s1.13,6.06,1.71,9.19c.3,1.57.59,3.15.89,4.75l.45,2.42a3.11,3.11,0,0,1-.29,2.56,1.24,1.24,0,0,1-1.33.45,3.53,3.53,0,0,1-1.19-.61l-2-1.52a47.64,47.64,0,0,0-4.24-2.86,16.41,16.41,0,0,0-4.74-2,5.5,5.5,0,0,0-2.52,0,3.69,3.69,0,0,0-2.06,1.38,8.45,8.45,0,0,0-1.35,5,28.44,28.44,0,0,0,.53,5.42,68.67,68.67,0,0,0,3.05,10.78,14.8,14.8,0,0,1,.87,2.78,2,2,0,0,1-.37,1.55,2.65,2.65,0,0,1-.29.29,1.14,1.14,0,0,1-.39.23,1.22,1.22,0,0,1-.87-.2,14.47,14.47,0,0,1-2.31-1.84l-2.14-2a31.85,31.85,0,0,0-4.55-3.66,9.46,9.46,0,0,0-2.63-1.2,3.27,3.27,0,0,0-2.67.33,3.87,3.87,0,0,0-1.51,2.32,11.86,11.86,0,0,0-.36,2.92,25.31,25.31,0,0,0,.75,6,51.68,51.68,0,0,0,4.35,11.49,86.32,86.32,0,0,0,6.47,10.75,58.35,58.35,0,0,0,3.9,5c1.34,1.66,2.7,3.31,4.06,5l0,.06-.24-.1,6.36-.92a61.22,61.22,0,0,0,6.27-1.08,88.37,88.37,0,0,0,12-3.61,52.29,52.29,0,0,0,10.95-5.59,24.53,24.53,0,0,0,4.57-3.91,11.74,11.74,0,0,0,1.71-2.41,3.88,3.88,0,0,0,.44-2.73,3.26,3.26,0,0,0-1.75-2.05,10,10,0,0,0-2.75-.88,32.44,32.44,0,0,0-5.83-.35l-2.92,0a14.73,14.73,0,0,1-3-.19,1.19,1.19,0,0,1-.78-.44,1.12,1.12,0,0,1-.13-.44,1.85,1.85,0,0,1,0-.41,2.07,2.07,0,0,1,.77-1.39,15.05,15.05,0,0,1,2.51-1.47,67.88,67.88,0,0,0,9.51-5.93,27.07,27.07,0,0,0,4-3.66,8.44,8.44,0,0,0,2.36-4.6,3.7,3.7,0,0,0-.6-2.41,5.43,5.43,0,0,0-1.86-1.7,16.22,16.22,0,0,0-4.83-1.73,46,46,0,0,0-5.06-.73l-2.52-.24a3.24,3.24,0,0,1-1.29-.35,1.25,1.25,0,0,1-.67-1.24,3.16,3.16,0,0,1,1.51-2.08l2-1.48,3.85-2.93,7.44-5.65c2.39-1.87,4.94-3.45,6.74-5.69a8.07,8.07,0,0,0,1.84-3.68,4.73,4.73,0,0,0-.94-3.75,3.4,3.4,0,0,0-1.63-1,7.87,7.87,0,0,0-1.93-.32,30.92,30.92,0,0,0-3.86.14c-.64,0-1.28.09-1.91.1a3.4,3.4,0,0,1-1.89-.41,2.31,2.31,0,0,1-1-1.65,5.28,5.28,0,0,1,.11-1.86h0v0A182.14,182.14,0,0,0,426,198.86c2-5,3.73-9.3,4.35-13a17,17,0,0,0,.2-4.9,7.82,7.82,0,0,0-1.17-3.34,4.63,4.63,0,0,0-1.54-1.51,4.09,4.09,0,0,0-.67-.33,2.78,2.78,0,0,1,.69.29,4.73,4.73,0,0,1,1.6,1.5,8,8,0,0,1,1.21,3.37,16.81,16.81,0,0,1-.15,4.95c-.6,3.71-2.3,8-4.29,13a182.36,182.36,0,0,1-7.62,16.87l0,0a4.73,4.73,0,0,0-.1,1.72,2,2,0,0,0,.82,1.43,3.1,3.1,0,0,0,1.7.35c.62,0,1.25-.06,1.89-.11a31.49,31.49,0,0,1,3.91-.15,8.2,8.2,0,0,1,2,.33,3.84,3.84,0,0,1,1.8,1.07,5.1,5.1,0,0,1,1,4,8.34,8.34,0,0,1-1.92,3.86c-1.85,2.3-4.42,3.9-6.79,5.78l-7.43,5.66-3.84,2.92-1.95,1.49a4.56,4.56,0,0,0-.89.78,2.07,2.07,0,0,0-.46,1,.82.82,0,0,0,.45.82,2.94,2.94,0,0,0,1.13.29l2.52.24a45,45,0,0,1,5.1.73,16.86,16.86,0,0,1,5,1.77,6.12,6.12,0,0,1,2,1.85,4.25,4.25,0,0,1,.68,2.69,9,9,0,0,1-2.47,4.88,28.47,28.47,0,0,1-4.1,3.73,69.1,69.1,0,0,1-9.57,6,14.19,14.19,0,0,0-2.42,1.4,1.56,1.56,0,0,0-.6,1.06,1.51,1.51,0,0,0,0,.3c0,.08,0,.27.07.26a.85.85,0,0,0,.46.21,14.7,14.7,0,0,0,2.84.18l2.92,0a31.12,31.12,0,0,1,5.92.35,9.82,9.82,0,0,1,2.9.93,3.77,3.77,0,0,1,2,2.37,4.34,4.34,0,0,1-.48,3.08,12,12,0,0,1-1.78,2.51,25.07,25.07,0,0,1-4.66,4,51.94,51.94,0,0,1-11.06,5.65,87.6,87.6,0,0,1-12.1,3.64,60.31,60.31,0,0,1-6.29,1.08l-6.37.93-.15,0-.09-.12-.05,0-4.06-5a61.16,61.16,0,0,1-3.91-5,86.89,86.89,0,0,1-6.52-10.83,52.43,52.43,0,0,1-4.37-11.61,25,25,0,0,1-.77-6.09,12.63,12.63,0,0,1,.38-3.06,4.39,4.39,0,0,1,1.72-2.6,3.77,3.77,0,0,1,3.08-.4,10,10,0,0,1,2.76,1.26,31.74,31.74,0,0,1,4.62,3.72l2.14,2a14.6,14.6,0,0,0,2.22,1.77.85.85,0,0,0,.49.16s.15-.09.22-.14l.22-.22a1.53,1.53,0,0,0,.26-1.18,13.94,13.94,0,0,0-.84-2.67,69,69,0,0,1-3.06-10.86,28.49,28.49,0,0,1-.53-5.51,8.92,8.92,0,0,1,1.46-5.28,4.19,4.19,0,0,1,2.3-1.54,6,6,0,0,1,2.73,0,16.79,16.79,0,0,1,4.87,2,44.49,44.49,0,0,1,4.28,2.89l2,1.52a3.23,3.23,0,0,0,1,.55.82.82,0,0,0,.89-.3,2,2,0,0,0,.33-1,4.4,4.4,0,0,0-.13-1.18c-.15-.81-.29-1.61-.44-2.41-.3-1.6-.59-3.19-.88-4.75-.57-3.14-1.14-6.2-1.69-9.19s-1.32-5.89-1.15-8.84a8.49,8.49,0,0,1,1.18-4.15,5.08,5.08,0,0,1,3.49-2.3,3.79,3.79,0,0,1,2.05.41,8.23,8.23,0,0,1,1.71,1.11,31.59,31.59,0,0,1,2.8,2.74q.64.7,1.32,1.35a3.17,3.17,0,0,0,1.5.89,2,2,0,0,0,1.57-.51,4.79,4.79,0,0,0,1.08-1.34v0a180,180,0,0,1,5.72-17.65c1.9-5.05,3.54-9.4,5.63-12.54a16.63,16.63,0,0,1,3.26-3.74,7.88,7.88,0,0,1,3.21-1.6,4.79,4.79,0,0,1,2.2,0A2.59,2.59,0,0,1,427.33,175.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.08,189.45a1.2,1.2,0,0,1-.1.33l-.34.94c-.33.85-.79,2.06-1.37,3.59-1.22,3.15-2.95,7.66-5.09,13.21l-16.61,43.64c-6.46,17-12.38,32.47-16.76,43.59-2.18,5.56-4,10.05-5.24,13.15-.62,1.52-1.11,2.71-1.46,3.55-.17.39-.29.69-.39.93l-.15.3a1.2,1.2,0,0,1,.1-.32c.08-.24.2-.55.34-.94.33-.86.79-2.06,1.37-3.6,1.22-3.15,2.95-7.65,5.09-13.2L398.08,251c6.46-17.05,12.37-32.46,16.76-43.58,2.18-5.56,4-10.06,5.24-13.15.62-1.52,1.11-2.72,1.46-3.56.17-.38.29-.69.39-.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,224a17.3,17.3,0,0,1-2.5,1.49l-6.12,3.4c-2.4,1.33-4.58,2.52-6.19,3.33a13.71,13.71,0,0,1-2.67,1.16,20.33,20.33,0,0,1,2.5-1.49l6.1-3.45c2.4-1.33,4.59-2.49,6.21-3.28A15.24,15.24,0,0,1,422.62,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.33,232.74c-.13.06-2.51-4.48-5.31-10.14s-5-10.3-4.85-10.37,2.51,4.48,5.32,10.14S404.46,232.67,404.33,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,259.37a14.7,14.7,0,0,1-2.2-2c-1.3-1.3-3-3.15-4.85-5.29s-3.35-4.16-4.41-5.66a14.11,14.11,0,0,1-1.61-2.5,20.81,20.81,0,0,1,1.9,2.28c1.14,1.44,2.71,3.41,4.52,5.54s3.49,4,4.71,5.37A19.79,19.79,0,0,1,395.59,259.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.88,255.07a14.81,14.81,0,0,1-2.64.78c-1.64.41-3.92.94-6.44,1.5s-4.82,1-6.48,1.36a14.16,14.16,0,0,1-2.72.41,14.73,14.73,0,0,1,2.64-.77c1.64-.41,3.92-1,6.45-1.51s4.81-1,6.47-1.35A14.92,14.92,0,0,1,413.88,255.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.15,279.57a24.56,24.56,0,0,1-3.4.91c-2.12.49-5,1.14-8.28,1.82s-6.19,1.28-8.32,1.68a22.77,22.77,0,0,1-3.47.55,23.53,23.53,0,0,1,3.4-.91c2.11-.49,5-1.14,8.28-1.82s6.18-1.28,8.31-1.68A22.78,22.78,0,0,1,409.15,279.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.2,284.25a3.89,3.89,0,0,1-.75-.68c-.46-.46-1.1-1.14-1.89-2-1.57-1.72-3.68-4.15-5.9-6.92s-4.13-5.37-5.46-7.28c-.67-.95-1.19-1.73-1.54-2.28a3.56,3.56,0,0,1-.5-.89,4.16,4.16,0,0,1,.66.77l1.68,2.19c1.4,1.85,3.35,4.4,5.57,7.16s4.27,5.23,5.77,7A28.59,28.59,0,0,1,386.2,284.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,351.24c-17.36-14-19.88-37.93-17.7-59.14.37-3.54.23-7.31,2.13-10.31s6-4.85,9.07-3.14c2.55,1.42,3.48,4.57,4.78,7.2a20.84,20.84,0,0,0,7.78,8.52c2.18,1.33,4.93,2.24,7.24,1.16,3.18-1.48,3.83-5.68,4.05-9.21l1.23-19.74c.22-3.54.46-7.14,1.79-10.41s4-6.22,7.39-6.94,7.44,1.52,7.91,5a32.48,32.48,0,0,1-.2,4.4c0,1.47.57,3.14,1.93,3.64s2.86-.39,4-1.35c3.89-3.31,6.67-7.73,9.3-12.14s5.18-8.93,8.76-12.59,8.35-6.43,13.43-6.37,10.24,3.55,11.18,8.6-2.31,9.92-5.75,13.73A78.93,78.93,0,0,1,437,266.68a6.48,6.48,0,0,0-3,2.76c-.93,2.3,1.14,4.79,3.41,5.73,2.57,1.05,5.45,1,8.18,1.49s5.63,1.93,6.49,4.6c1.2,3.71-2.08,7.28-5.22,9.56A67.75,67.75,0,0,1,426.19,301c-2.67.77-5.46,1.41-7.68,3.09s-3.7,4.77-2.6,7.34,4.29,3.6,7,3.28,5.29-1.63,7.95-2.43c5-1.5,11.22-.73,14,3.67,1.85,2.9,1.77,6.75.51,10a25.88,25.88,0,0,1-5.95,8.36,68,68,0,0,1-30.38,18.38c-11.52,3.13-22,3.47-32.92-1.39",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.2,351.24c-17.36-14-19.88-37.93-17.7-59.14.37-3.54.23-7.31,2.13-10.31s6-4.85,9.07-3.14c2.55,1.42,3.48,4.57,4.78,7.2a20.84,20.84,0,0,0,7.78,8.52c2.18,1.33,4.93,2.24,7.24,1.16,3.18-1.48,3.83-5.68,4.05-9.21l1.23-19.74c.22-3.54.46-7.14,1.79-10.41s4-6.22,7.39-6.94,7.44,1.52,7.91,5a32.48,32.48,0,0,1-.2,4.4c0,1.47.57,3.14,1.93,3.64s2.86-.39,4-1.35c3.89-3.31,6.67-7.73,9.3-12.14s5.18-8.93,8.76-12.59,8.35-6.43,13.43-6.37,10.24,3.55,11.18,8.6-2.31,9.92-5.75,13.73A78.93,78.93,0,0,1,437,266.68a6.48,6.48,0,0,0-3,2.76c-.93,2.3,1.14,4.79,3.41,5.73,2.57,1.05,5.45,1,8.18,1.49s5.63,1.93,6.49,4.6c1.2,3.71-2.08,7.28-5.22,9.56A67.75,67.75,0,0,1,426.19,301c-2.67.77-5.46,1.41-7.68,3.09s-3.7,4.77-2.6,7.34,4.29,3.6,7,3.28,5.29-1.63,7.95-2.43c5-1.5,11.22-.73,14,3.67,1.85,2.9,1.77,6.75.51,10a25.88,25.88,0,0,1-5.95,8.36,68,68,0,0,1-30.38,18.38c-11.52,3.13-22,3.47-32.92-1.39"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,367a155.74,155.74,0,0,1,7.76-28.69,317.86,317.86,0,0,1,14.89-33.19l4.35-8.5c1.44-2.79,2.86-5.55,4.42-8.17a160.42,160.42,0,0,1,9.81-14.52c3.35-4.47,6.68-8.59,9.83-12.42s6.17-7.33,9.05-10.41a126.36,126.36,0,0,1,14.66-13.51c1.85-1.45,3.32-2.53,4.33-3.25l1.15-.81a3.21,3.21,0,0,1,.4-.26,1.71,1.71,0,0,1-.36.31l-1.11.87c-1,.75-2.43,1.86-4.25,3.35a132.45,132.45,0,0,0-14.48,13.62c-2.85,3.09-5.84,6.61-9,10.44s-6.45,8-9.77,12.44a156.66,156.66,0,0,0-9.74,14.48c-1.55,2.61-3,5.35-4.39,8.14l-4.35,8.5a327.48,327.48,0,0,0-14.91,33.1,159,159,0,0,0-7.87,28.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.45,288.42a6.85,6.85,0,0,1-.25-1.53c-.11-1-.24-2.42-.37-4.2-.25-3.54-.44-8.46-.63-13.87s-.45-10.32-.76-13.86c-.15-1.76-.28-3.19-.39-4.18a6.71,6.71,0,0,1-.09-1.55,7.85,7.85,0,0,1,.34,1.51c.18,1,.39,2.41.6,4.18.43,3.53.76,8.44,1,13.87s.33,10.18.44,13.88c.07,1.67.12,3.07.17,4.2A8.1,8.1,0,0,1,406.45,288.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.41,283.05a9.14,9.14,0,0,1-1.83.1c-1.17,0-2.86,0-5,.14-4.18.17-10,.59-16.31,1.35s-12.07,1.69-16.19,2.49c-2.06.38-3.72.74-4.87,1a10.39,10.39,0,0,1-1.8.31,10.38,10.38,0,0,1,1.74-.56c1.13-.32,2.78-.74,4.84-1.19,4.1-.91,9.83-1.92,16.2-2.69a160,160,0,0,1,16.38-1.15c2.1,0,3.8,0,5,.06A10.41,10.41,0,0,1,452.41,283.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,337.49a2.06,2.06,0,0,1-.27-.57l-.67-1.7c-.57-1.47-1.34-3.63-2.25-6.3-1.83-5.35-4.13-12.82-6.56-21.09s-4.65-15.76-6.37-21.14c-.84-2.62-1.54-4.77-2.05-6.37l-.55-1.73a2.35,2.35,0,0,1-.15-.62,2.5,2.5,0,0,1,.27.57c.18.46.4,1,.66,1.7.57,1.47,1.34,3.63,2.26,6.3,1.83,5.35,4.13,12.82,6.55,21.1s4.66,15.75,6.38,21.13c.84,2.62,1.53,4.77,2,6.37l.55,1.73A2.35,2.35,0,0,1,383.22,337.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,322.19a2,2,0,0,1-.62.21l-1.79.47-6.6,1.65c-5.58,1.39-13.25,3.4-21.73,5.64s-16.18,4.18-21.79,5.46c-2.8.64-5.07,1.14-6.65,1.45l-1.82.35a2.36,2.36,0,0,1-.64.07,2.49,2.49,0,0,1,.61-.2l1.8-.47,6.6-1.65c5.57-1.39,13.25-3.41,21.73-5.65s16.18-4.18,21.78-5.46c2.8-.64,5.08-1.13,6.65-1.44l1.82-.35A2.82,2.82,0,0,1,444.86,322.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Checklist--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.73,
    y: 75.19,
    width: 242.51,
    height: 332.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.65 387.73 325.74 387.73 157.93 387.73 157.93 88.62 370.65 88.62 370.65 350.52 370.65 387.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.29 382.18 322.78 382.18 156.48 382.18 156.48 84.67 367.29 84.67 367.29 345.17 367.29 382.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.64 359.03 320.36 378.8 152.55 378.8 152.55 85.42 365.27 85.42 365.27 342.3 344.64 359.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,359s.43-.37,1.3-1.08l3.89-3.18,15.39-12.53,0,.06c0-42.2-.08-136-.15-256.88l.23.24-210.87,0h-1.85l.26-.26c0,110.3,0,212.05-.06,293.38l-.2-.21,167.81.12-.06,0,18.24-14.79,4.57-3.69c1-.82,1.53-1.22,1.53-1.22l-1.5,1.25L338.6,364l-18.18,14.86,0,0h0L152.55,379h-.21v-.21c0-81.33,0-183.08-.05-293.38v-.26h2.11l210.87,0h.24v.23c-.07,120.92-.13,214.68-.15,256.88v0l0,0-15.45,12.47L346,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.21,64.92h58.15a14.15,14.15,0,0,1,14.15,14.15V94.76a0,0,0,0,1,0,0H215.45a0,0,0,0,1,0,0V79.67A14.76,14.76,0,0,1,230.21,64.92Z",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.78 64.92 233.6 48.82 283.73 48.82 280.94 64.92 236.78 64.92",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,168H174.8V132.16h35.83Zm-34.83-1h33.83V133.16H175.8Z",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,140.82c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,140.67,337.28,140.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,148.26c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,148.12,337.28,148.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,155.71c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,155.57,337.28,155.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,163.16c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,163,337.28,163.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,223.23H174.8V187.39h35.83Zm-34.83-1h33.83V188.39H175.8Z",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.92 206.05 186.68 200.94 194.61 207.28 212.76 189.66 217.11 194.79 194.26 217.33 181.92 206.05",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,196.05c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,195.91,337.28,196.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,203.5c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,203.35,337.28,203.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,210.94c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,210.8,337.28,210.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,218.39c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,218.25,337.28,218.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,276.68H174.8V240.84h35.83Zm-34.83-1h33.83V241.84H175.8Z",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.92 259.5 186.68 254.39 194.61 260.73 212.76 243.11 217.11 248.24 194.26 270.78 181.92 259.5",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,249.5c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,249.35,337.28,249.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,256.94c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,256.8,337.28,256.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,264.39c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,264.25,337.28,264.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,271.84c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,271.7,337.28,271.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,328.29H174.8V292.45h35.83Zm-34.83-1h33.83V293.45H175.8Z",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.92 311.11 186.68 306 194.61 312.34 212.76 294.72 217.11 299.84 194.26 322.38 181.92 311.11",
    style: {
      fill: "#0E9B8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,301.1c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,301,337.28,301.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,308.55c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,308.41,337.28,308.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,316c0,.14-24.95.26-55.71.26s-55.72-.12-55.72-.26,24.94-.26,55.72-.26S337.28,315.85,337.28,316Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.28,323.44c0,.15-24.95.26-55.71.26s-55.72-.11-55.72-.26,24.94-.26,55.72-.26S337.28,323.3,337.28,323.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.03 330.23 303.71 378.53 320.36 378.53 327.03 330.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.36 378.8 327.03 330.5 365.27 342.3 320.36 378.8",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.36,378.8l12.86-10.59,31.89-26.11.09.44L350.43,338,327,330.73l.31-.2c-2,14-3.71,26.05-4.92,34.59-1.21,8.31-1.83,12.6-2,13.68a2.1,2.1,0,0,1,0-.22l.09-.66c.08-.63.19-1.51.34-2.63.31-2.35.75-5.72,1.31-10,1.16-8.61,2.78-20.72,4.67-34.87l0-.28.27.08,23.49,7.24,14.76,4.56.46.14-.37.3c-12.91,10.41-24.2,19.51-32.28,26l-9.43,7.57-2.52,2-.64.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "280.26 48.82 277.5 64.92 280.94 64.92 283.73 48.82 279.34 48.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.57c266005d2d7b5a2b9ba0ea636cfb07.svg";
export { ForwardRef as ReactComponent };